import script from "./TechnicalPropertyTableValue.vue?vue&type=script&setup=true&lang=js"
export * from "./TechnicalPropertyTableValue.vue?vue&type=script&setup=true&lang=js"

import "./TechnicalPropertyTableValue.vue?vue&type=style&index=0&id=6856f3c2&lang=less"

const __exports__ = script;

export default __exports__